// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f3KA","type":"styles_type__3e0hi","choices":"styles_choices__3SWNT"};